import RadioButton from './RadioButton';
import { BaseRadioButtonProps } from '../../types/buttons.type';

export default function RadioButtonGroup({
  options,
  selected,
  onChange,
  name,
}: {
  options: BaseRadioButtonProps[];
  selected: string;
  onChange: (value: string) => void;
  name: string;
}) {
  return (
    options.map((option) => (
      <RadioButton
        key={option.value}
        value={option.value}
        name={name}
        checked={option.value === selected}
        onChange={onChange}
        label={option.label}
        disabled={option.disabled}
        tooltip={option.tooltip}
      />
    ))
  );
}
